export default {
  setIsVerificationSkip(state, isVerificationSkip) {
    state.isVerificationSkip = isVerificationSkip;
  },
  setSkipEmailVerification(state, skipEmailVerification) {
    state.skipEmailVerification = skipEmailVerification;
  },
  setDisableEmailVerification(state, disableEmailVerification) {
    state.disableEmailVerification = disableEmailVerification;
  },
  setIsPaidAccount(state, isPaidAccount) {
    state.isPaidAccount = isPaidAccount;
  },
  setIsEmailVerified(state, isEmailVerified) {
    state.isEmailVerified = isEmailVerified;
  },
  setEmailVerificationCode(state, code) {
    state.emailVerificationCode = code;
  },
  setEmailVerificationCodeError(state, emailVerificationCodeError) {
    state.emailVerificationCodeError = emailVerificationCodeError;
  },
};
